export default "__VITE_ASSET__BrWKR6bf__"